export const paths = {
    BOOKAPPOINTMENT: 'bookappointment',
    OTPVERIFICATION: 'otpverification',
    CARLIST: 'carlist',
    CARSERVICE: 'carservice',
    CARSERVICELIST: 'carservicelist',
    CONFIRMBOOKING: 'confirmbooking',
    BOOKINGSUMMARY: 'bookingsummary',
    DEALERSELECTION: 'dealerselection',
    PRIVACYPOLICY: 'privacy',
};

export const months = {
    // tslint:disable-next-line:object-literal-key-quotes
    NO: {
         months: ['januar', 'februar', 'mars', 'april', 'mai', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'desember'],
    },
  };